/* eslint-disable react/forbid-prop-types */
/* eslint-disable react-hooks/exhaustive-deps */
// import { MdStarBorder, MdStar } from 'react-icons/md';
import React, { useState, useEffect } from 'react';
// import { useSelector } from 'react-redux';;

import PropTypes from 'prop-types';

import { Button } from '@material-ui/core';

import AppConfigRobotType from '~/components/AppConfigRobotType';
// import ExitDialog from '~/components/ExitDialog';
import FormSelect from '~/components/Form/Select';
import LocaleMessage from '~/components/LocaleMessage';
import Splash from '~/components/Splash/Inside';

import api from '~/services/pluginbot-api';

const nav_features = {
    cruzr: {
        max_speed: true,
        reference_point_id: true,
        show_location: true,
        speed_selection: true,
    },
    temi_go: {
        reference_point_id: true,
    },
};

export default function MapNavigation({
    app,
    group,
    handleError,
    updateObject,
    // needSaving,
    setNeedSaving,
    robotTypes,
    currType,
    setCurrType,
}) {
    // const _settings = useSelector(state => state.settings || null);
    const { app_type } = app;
    const appSettings = app && app.settings ? app.settings : {};

    const [isLoading, setIsLoading] = useState(false);
    const [maps, setMaps] = useState([]);
    const [points, setPoints] = useState([]);
    const [mapNavigation, setMapNavigation] = useState(
        appSettings && appSettings.map_navigation
            ? appSettings.map_navigation
            : {}
    );

    const r_key = currType.slug ? currType.slug : 'all';
    const r_type_settings = mapNavigation[r_key] || {};
    const robot_features = nav_features[r_key] || {};

    async function loadMapPoints(_id) {
        if (_id) {
            setIsLoading(true);
            await api
                .get(`map_points?map_layer=${_id}`)
                .then(response => {
                    const data = response.data.map(z => ({
                        id: z.id,
                        name: z.name,
                        reference: z.reference,
                    }));
                    setPoints(data);
                })
                .catch(error => handleError(error));
        } else {
            setPoints([]);
        }
        setIsLoading(false);
    }

    async function loadMaps(r_id) {
        setIsLoading(true);
        await api
            .get(`map_layers?robot=${r_id}&&application=${app_type.id}`)
            .then(async response => {
                const filtered = response.data.filter(m => {
                    return m.group && m.group.id === group;
                });
                const data = filtered.map(m => {
                    return {
                        ...m,
                        name: m.map ? m.map.name : '',
                        label: `${m.map ? m.map.name : ''} [${m.reference}]`,
                    };
                });
                setMaps(data);
            })
            .catch(error => handleError(error));
        setIsLoading(false);
    }

    useEffect(() => {
        if (app_type && app_type.id) {
            loadMaps(currType.id);
        }
    }, [app_type, currType]);

    useEffect(() => {
        loadMapPoints(r_type_settings.map_layer_id);
    }, [r_type_settings.map_layer_id, currType]);

    // function buildConfirmDialog() {
    //     return (
    //         <ExitDialog
    //             open={dialogOpen}
    //             onClose={() => setDialogOpen(false)}
    //             destination="/tools/maps"
    //         />
    //     );
    // }

    async function handleSubmit() {
        const data = { map_navigation: mapNavigation };
        updateObject(data);
    }

    function setCurrTypeSettings(key, value) {
        setNeedSaving(true);
        const updated = {
            ...mapNavigation,
            [r_key]: {
                ...r_type_settings,
                [key]: value,
            },
        };
        setMapNavigation(updated);
    }

    function renderSubmitButton() {
        return (
            <div className="col-12 mt-2">
                <Button
                    className="p-3"
                    variant="contained"
                    color="primary"
                    onClick={() => handleSubmit()}
                    fullWidth
                    size="large"
                    // disabled={!needSaving}
                >
                    <LocaleMessage msg="button.save" />
                </Button>
            </div>
        );
    }

    function renderMapConfig() {
        return (
            <div
                className="col-12 mt-1 row"
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                }}
            >
                {/* Map and Reference Point */}
                <div className="col-12">
                    <FormSelect
                        classes="mb-5"
                        options={maps}
                        labelKey="label"
                        label={
                            <LocaleMessage msg="page.applications.conversation.map_navigation.current" />
                        }
                        value={
                            r_type_settings.map_layer_id
                                ? r_type_settings.map_layer_id
                                : ''
                        }
                        onChange={value => {
                            setCurrTypeSettings('map_layer_id', value, true);
                        }}
                    />

                    {r_type_settings.map_layer_id ? (
                        <>
                            {robot_features.reference_point_id ? (
                                <FormSelect
                                    classes="mb-5"
                                    options={points}
                                    labelKey="name"
                                    label={
                                        <LocaleMessage msg="page.applications.conversation.map_navigation.reference_point" />
                                    }
                                    value={
                                        r_type_settings.reference_point_id
                                            ? r_type_settings.reference_point_id
                                            : ''
                                    }
                                    onChange={value => {
                                        setCurrTypeSettings(
                                            'reference_point_id',
                                            value
                                        );
                                    }}
                                    helper={
                                        <LocaleMessage msg="page.applications.conversation.map_navigation.reference_point.helper" />
                                    }
                                />
                            ) : null}
                        </>
                    ) : null}
                </div>
            </div>
        );
    }

    return (
        <div className="col-12 mb-3 row">
            <div className="sidecard-header">
                <h2>
                    <LocaleMessage msg="page.applications.conversation.map_navigation.title" />
                </h2>
            </div>

            <div className="sidecard-body">
                {isLoading ? (
                    <Splash />
                ) : (
                    <>
                        <div
                            className="col-12"
                            style={{
                                display: 'flex',
                                flexDirection: 'column',
                                justifyContent: 'center',
                                alignItems: 'center',
                            }}
                        >
                            <AppConfigRobotType
                                className="col-12 mb-5"
                                robotTypes={robotTypes}
                                currType={currType}
                                setCurrType={t => setCurrType(t)}
                            >
                                <div
                                    className="col-md-6 col-12 row mb-5"
                                    style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                    }}
                                >
                                    {renderMapConfig()}
                                    {renderSubmitButton()}
                                </div>
                            </AppConfigRobotType>
                        </div>
                    </>
                )}
            </div>
        </div>
    );
}

MapNavigation.defaultProps = {};

MapNavigation.propTypes = {
    app: PropTypes.object.isRequired,
    group: PropTypes.string.isRequired,
    updateObject: PropTypes.func.isRequired,
    handleError: PropTypes.func.isRequired,
    // needSaving: PropTypes.bool.isRequired,
    setNeedSaving: PropTypes.func.isRequired,
    robotTypes: PropTypes.array.isRequired,
    currType: PropTypes.object.isRequired,
    setCurrType: PropTypes.func.isRequired,
};
